export enum VariationEnum {
    VARIATION_A = 'VARIATION_A',
    VARIATION_B = 'VARIATION_B',
}
export const INFLATION_ABC_TEST = 'AB_test_transparence_prix';
export const PHONE_AB_TEST = 'AB_test_boost_terminaux';

type VariationOptionType = {
    VARIATION_A: {
        value: 'a';
        key: VariationEnum.VARIATION_A;
        randomChance: number;
    };
    VARIATION_B: {
        value: 'b';
        key: VariationEnum.VARIATION_B;
        randomChance: number;
    };
};
export const variationOption: VariationOptionType = {
    [VariationEnum.VARIATION_A]: {
        value: 'a',
        key: VariationEnum.VARIATION_A,
        randomChance: 50,
    },
    VARIATION_B: {
        value: 'b',
        key: VariationEnum.VARIATION_B,
        randomChance: 50,
    },
};

export function weightedRandom(chanceTo: VariationOptionType): VariationEnum | null {
    let sum = 0;
    const random = Math.random() * 100;

    for (const [name, option] of Object.entries(chanceTo)) {
        sum += option.randomChance;
        if (random <= sum) {
            return name as VariationEnum;
        }
    }
    return null;
}
